import { post } from './httpClient'

export const register = (body) => post('/authorization/register', body)
